export const home = {
  title: '项目管理',
  progress: '施工进度',
  dynamic: '施工动态',
  drawing: '施工图',
  message: '消息',
  connector: '联系人',
  profile: '我的',
  developing: '开发中',
  total: '项目总数',
  delay: '延期进度',
  inspect: '进度验收',
  message1: '您有一份新手指引待查收',
  message2: '30天限时案例，去看看吧~',
  message3: '您还没有项目,请先加入项目或者在PC端创建项目',
  skip: '跳过',
  watch: '去看看'
};
